package com.essntl.features.contact.ui

import com.essntl.features.contact.domain.model.ContactModel
import com.essntl.features.organization.domain.model.OrganizationModel

sealed interface ContactEvent {
    data class GetContacts(
        val type: OrganizationModel.Type,
        val searchText: String = "",
    ) : ContactEvent

    data class GetOrganizationContacts(
        val organizationId: String,
        val searchText: String = "",
    ) : ContactEvent

    data class GetContact(val id: String) : ContactEvent
    data object AddContact : ContactEvent
    data object EditContact : ContactEvent
    data class UpdateContactFields(val contact: ContactModel) : ContactEvent
    data class AddRemoveAddress(val addAddress: Boolean? = null) : ContactEvent
    data object ClearContactState : ContactEvent
    data object ClearSuccessState : ContactEvent
}